import classNames from 'classnames';
import { useSearchParamsHelper } from 'hooks/useSearchParamsHelper';
import { Link, useLocation, useSearchParams } from 'react-router-dom';

export const Pagination = ({ totalItems, itemsPerPage }) => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const { addParams, removeParam } = useSearchParamsHelper();

  if (!totalItems) {
    return null;
  }

  const currentPage = +searchParams.get('p');
  const pages = Math.ceil(totalItems / itemsPerPage);

  return (
    <div
      className={classNames({
        hidden: process.env.REACT_APP_SHOW_PAGINATION === 'false',
      })}
    >
      <Link to={`${pathname}?${addParams({ p: 1 })}`}>First</Link>
      {currentPage > 1 && (
        <Link to={`${pathname}?${addParams({ p: currentPage - 1 })}`}>
          Previous
        </Link>
      )}
      {new Array(pages).fill(1).map((page, index) => (
        <Link key={index} to={`${pathname}?${addParams({ p: index + 1 })}`}>
          {index + 1}
        </Link>
      ))}
      {currentPage < pages && (
        <Link to={`${pathname}?${addParams({ p: currentPage + 1 })}`}>
          Next
        </Link>
      )}
      <Link to={`${pathname}?${addParams({ p: pages })}`}>Last</Link>
      <Link to={`${pathname}?${removeParam('p')}`}>Show All</Link>
    </div>
  );
};
